var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"success","disabled":_vm.disabled},on:{"click":_vm.downloadFile}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-file-excel-box ")]),_vm._v(" Excel ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }